import React from 'react';
import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import LoadingSpinner from '../layout/LoadingSpinner';
import EmptyState from '../common/EmptyState';
import ReviewerCampaignCard from './ReviewerCampaignCard';

/**
 * Grid of campaigns the current user has been invited to compliance-review.
 *
 * Visual parallel of `CampaignList`, but read-only (no rename / delete) and
 * scoped to shares where the user is the *invited* reviewer, not the
 * owner. The empty-state copy is intentionally generic — when no shares
 * exist, the parent (HomePage) doesn't render the tab at all, so this
 * empty branch is only ever shown if the user revokes their last accepted
 * share mid-session.
 */
const ReviewerCampaignList = ({ shares, isLoading, error }) => {
  if (isLoading) {
    return <LoadingSpinner message="Loading shared campaigns..." />;
  }

  if (error) {
    return (
      <Box
        p={4}
        bg="#2A2F36"
        color="red.400"
        borderRadius="md"
        borderColor="red.500"
        borderWidth="1px"
      >
        <Text>Error loading shared campaigns: {error.message}</Text>
      </Box>
    );
  }

  if (!shares || shares.length === 0) {
    return (
      <EmptyState
        title="Nothing shared with you yet"
        message="When someone invites you to compliance-review one of their campaigns, it'll show up here."
        bgColor="#2A2F36"
        textColor="white"
      />
    );
  }

  return (
    <SimpleGrid columns={[1, null, 2, 3]} spacing={4} px={1}>
      {shares.map((share) => (
        <ReviewerCampaignCard key={share.share_id} share={share} />
      ))}
    </SimpleGrid>
  );
};

export default ReviewerCampaignList;
